// Public callback recovery code shared with the login screen.
export const GOOGLE_STATE_ERROR = 'google_state';
